import { createSlice } from '@reduxjs/toolkit';

export const loaderSlice = createSlice({
    name: 'mainLoader',
    initialState: {
        isLoading: false,
        isMiniLoader: false,
    },
    reducers: {
        showLoader: (state) => {
            state.isLoading = true;
        },
        hideLoader: (state) => {
            state.isLoading = false;
        },
        showMiniLoader: (state) => {
            state.isMiniLoader = true;
        },
        hideMiniLoader: (state) => {
            state.isMiniLoader = false;
        },
    },
});

export const { showLoader, hideLoader, showMiniLoader, hideMiniLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
